<template>
  <section>
    <qx-card title="订单信息" v-show="$route.query.showBaseInfo">
      <!-- 订单详情数据 -->
      <qx-detail-box :data="orderInfo" :colNum="3" />
      <!-- 订单详情数据 end -->
    </qx-card>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import {
  orderOverviewDetail,
} from 'api/operate';
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      orderInfo: {
        label: '基本信息',
        tableData: {
          title: [
            {
              prop: 'orderId',
              label: '订单编号',
            },
            {
              prop: 'statusName',
              label: '订单状态',
            },
            {
              prop: 'orderTypeName',
              label: '订单来源',
            },
          ],
          data: {

          },
          approveData: {

          },
        },
      },
    };
  },
  methods: {
    getData () {
      this.$refs.tableBox.getData();
      if (this.$route.query.showBaseInfo) {
        this.getDetail();
      }
    },
    getDetail () {
      orderOverviewDetail({
        orderId: this.$route.query.id,
      }).then((res) => {
        if (!res.failed) {
          this.orderInfo.tableData.data = res;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
